require("./threepl-service-status-selector.scss");

import {ChangeDetectionStrategy, Component, computed, inject, input, output} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {BzMenuItem} from "@bringoz/ui";
import {bzIconChevronDown} from "@bringoz/ui/icons";
import {THREE_PL_SERVICE_STATUS_ALL} from "../../constants/threepl-services.constant";

@Component({
  selector: "app-threepl-service-status-selector",
  templateUrl: "./threepl-service-status-selector.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServiceStatusSelectorComponent {
  readonly selectedStatus = input<string>();
  readonly statusList = input.required<string[]>();
  readonly statusChange = output<string | undefined>();

  readonly chevron = bzIconChevronDown;
  private readonly translate = inject(TranslateService);

  readonly items = computed<BzMenuItem[]>(() => [
    {id: THREE_PL_SERVICE_STATUS_ALL, label: this.translate.instant("All Statuses")},
    ...this.statusList().map((status) => ({id: status, label: this.translate.instant(`STATUS_TAG.${status}`)})),
  ]);

  onSelected(item: BzMenuItem): void {
    this.statusChange.emit(item.id === THREE_PL_SERVICE_STATUS_ALL ? undefined : item.id);
  }
}
